module.exports = __webpack_public_path__ + "static/img/m_faq_articles_read@3x.d056cbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_faq_articles_read@3x.png
// module id = IzVX
// module chunks = 1